import { Badge, Bank, Flex, LegacyCardList, Space, Typography, usePaypingContext } from "@payping/web-components";
import { CuToman, PhRIdentificationCard, PhRPhone } from "@payping/icons";
import { DisplayModeEnum } from "@payping/web-components/legacyComponents/List/types";
import type { ListCardProps } from "@payping/web-components/legacyComponents/List/types";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { useAppSelector } from "@/utils";
import { formatLocalizedNumber } from "@payping/utilities-shared/number";
import { getBankInfoFromSheba } from "@payping/utilities-shared/bank";

const ShowList = () => {
  const { t } = useAppTranslation();
  const { createdRequest } = useAppSelector((state) => state.cashOuts);
  const { breakpoints } = usePaypingContext();
  const { md } = breakpoints;

  const data: ListCardProps["dataSource"] = createdRequest?.settlements?.map((settlement) => ({
    actions: [
      <Flex key={1} align="center">
        <Typography.Text>{`${formatLocalizedNumber({ value: settlement?.amount ?? 0, options: { maximumFractionDigits: 2 } })}`}</Typography.Text>
        <CuToman width={24} height={24} />
      </Flex>,
    ],
    descriptions: (
      <Flex vertical={!md} gap={16}>
        {settlement?.iban ? (
          <Space>
            <Typography.Text type={"secondary"}>{settlement.iban}</Typography.Text>
            <Bank.Icon showTooltip bankName={getBankInfoFromSheba(settlement.iban ?? "")?.name} />
          </Space>
        ) : null}

        {settlement?.mobile ? (
          <Space>
            <Typography.Text type={"secondary"}>{settlement.mobile}</Typography.Text>
            <PhRPhone width={20} className="color--gray700" />
          </Space>
        ) : null}

        {settlement?.nationalId ? (
          <Space>
            <Typography.Text type={"secondary"}>{settlement.nationalId}</Typography.Text>
            <PhRIdentificationCard width={20} className="color--gray700" />
          </Space>
        ) : null}
      </Flex>
    ),
    title: {
      primary:
        settlement.fullName === " " ? (
          <Flex gap={"small"}>
            <Badge status={"error"} />
            <Typography.Title level={5}>{t("settlement.create.unclearInquiry")}</Typography.Title>
          </Flex>
        ) : (
          settlement.fullName
        ),
    },
    key: settlement.code || "",
  }));

  return (
    <LegacyCardList
      grid={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1, xxxl: 1, column: 0 }}
      dataSource={data}
      mode={md ? DisplayModeEnum.List : DisplayModeEnum.Card}
    />
  );
};

export default ShowList;
